import React from 'react';
import styled from 'styled-components';
const Text = styled.div`
  color: #64748B;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const Container = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 16px; 

  .policy-links {
    display: flex;
    align-items: center;
    gap: 40px;
    a.policy-link {
      color: #2D6772;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
    }
  }
`;
const Policy = () => {
  return (
    <Container>
      <Text>
        By submitting your contact information, you allow our salon to send you promotions exclusive offers and the latest info by email or SMS.<br />
        We’ll treat your information with the utmost care and will never sell them to other company for marketing purposes
      </Text>
      <div className="policy-links">
        <a href="#" className="policy-link">Privacy Policy</a>
        <a href="#" className="policy-link">Term of Use</a>
      </div>
    </Container>
  );
};

export default Policy;
